
import { Component, Vue } from 'vue-property-decorator'
import BEditableTable from 'bootstrap-vue-editable-table'
import { Diagnostic, RecordDiagnostic, Role } from '@/models/index'
import { getInsurances } from '@/components/insurances/insurance.service'
import { Debounce } from 'typescript-debounce'
import {
  createDiagnostic,
  getDiagnostics,
  updateDiagnostic
} from '@/components/diagnostics/diagnostics.service'
import Multiselect from 'vue-multiselect'
import { getUserRole } from '@/components/admin/users/users.service'
@Component({ components: { Multiselect, BEditableTable } })
export default class DiagnosticsView extends Vue {
  public value: Diagnostic[] = []
  public options: Diagnostic[] = []
  public items: Diagnostic[] = []
  public form = {} as Diagnostic
  public rowUpdate = {}
  public isEditing = false
  public showEditButton = false
  public fields = [
    {
      key: 'diagnosticId',
      label: 'Code'
    },
    {
      key: 'descriptions',
      label: 'Description',
      tdClass: 'align-middle',
      editable: true,
      type: 'text'
    },
    {
      key: 'cmshcc1',
      label: 'V28 CMSHcc1',
      tdClass: 'align-middle',
      editable: true
    },
    {
      key: 'cmshcc2',
      label: 'V28 CMSHcc2',
      tdClass: 'align-middle',
      editable: true,
      type: 'number'
    },
    // {
    //   key: 'cmshcc3',
    //   label: 'CMSHcc3',
    //   tdClass: 'align-middle',
    //   editable: true,
    //   type: 'number'
    // },
    {
      key: 'rxHcc1',
      label: 'RxHcc1',
      tdClass: 'align-middle',
      editable: true,
      type: 'number'
    },
    {
      key: 'rxHcc2',
      label: 'RxHcc2',
      tdClass: 'align-middle',
      editable: true,
      type: 'number'
    },
    {
      key: 'idinteraction',
      label: 'Interaction',
      tdClass: 'align-middle',
      editable: true,
      type: 'number'
    },
    {
      key: 'alert',
      label: 'Alert',
      tdClass: 'align-middle',
      editable: true
    },
    {
      key: 'radvAlert',
      label: 'RADV Alert',
      tdClass: 'align-middle',
      editable: true
    },
    {
      key: 'alertDelete',
      label: 'Delete',
      tdClass: 'align-middle',
      editable: true
    },
    // {
    //   key: 'documentation',
    //   label: 'Documentation',
    //   tdClass: 'align-middle',
    //   editable: true,
    //   type: 'text'
    // },
    {
      key: 'crosswalkDx',
      label: 'CrosswalkDx',
      tdClass: 'align-middle',
      editable: true
    },
    {
      key: 'crosswalkRx',
      label: 'CrosswalkRx',
      tdClass: 'align-middle',
      editable: true
    },
    {
      key: 'diagnosticStatus',
      label: 'Status',
      tdClass: 'align-middle'
    },
    // {
    //   key: "idInteraction",
    //   label: "ID Interaction",
    // },

    // {
    //   key: 'actions',
    //   label: 'Active',
    //   tdClass: 'align-middle'
    // },
    {
      key: 'actions',
      label: '',
      tdClass: 'align-middle'
    }
  ]

  public handleEdit(data: any) {
    this.isEditing = !this.isEditing
    this.rowUpdate = { edit: this.isEditing, id: data.id }
  }
  private numericOrNull(value: unknown): number | null {
    if (value === '' || value === null || value === undefined) return null
    const parsed = Number(value)
    return Number.isFinite(parsed) ? parsed : null
  }
  public async saveChanges() {
    const source = this.items[0]
    if (!source?.diagnosticId) return

    const payload: Diagnostic = {
      ...source,
      diagnosticId: String(source.diagnosticId).trim()
    }
    delete payload.rxHcc1Navigation
    delete payload.rxHcc2Navigation
    delete payload.rmtRecordsDetails
    try {
      await updateDiagnostic({
        ...payload,
        diagnosticId: String(source.diagnosticId).trim(),
        cmshcc1: this.numericOrNull(source.cmshcc1),
        cmshcc2: this.numericOrNull(source.cmshcc2),
        cmshcc3: this.numericOrNull(source.cmshcc3),
        rxHcc1: this.numericOrNull(source.rxHcc1),
        rxHcc2: this.numericOrNull(source.rxHcc2),
        idinteraction: this.numericOrNull(source.idinteraction),
        v24_Cmshcc1: this.numericOrNull(source.v24_Cmshcc1),
        v24_Cmshcc2: this.numericOrNull(source.v24_Cmshcc2),
        v24_Idinteraction: this.numericOrNull(source.v24_Idinteraction)
      } as Diagnostic)
      this.isEditing = false
    } catch {
      // The request interceptor already shows the API message.
    }
  }
  public handleSubmit(data) {
    this.isEditing = false

    const o = { ...this.items[0] }
    o.cmshcc1 = +data.item.cmshcc1
    this.rowUpdate = {
      edit: false,
      id: data.id,
      action: 'update'
    }

    updateDiagnostic(o)
    // console.log(this.rowUpdate)
  }
  public async created() {
    this._getDiagnostics(this.value)
    if (getUserRole() == Role.Admin) {
      this.showEditButton = true
    }
  }
  public onSelected(e: Diagnostic) {
    this.items = []
    this.items.push(e)
  }

  public customLabel({
    diagnosticId,
    descriptions
  }: {
    diagnosticId: string
    descriptions: string
  }): string {
    return `${diagnosticId} - ${descriptions}`
  }
  @Debounce({ millisecondsDelay: 1000 })
  public _getDiagnostics(value: any): void {
    // if (value.length >= 3) {
    getDiagnostics(1, 10, value).then(r => {
      this.options = r.data
    })
    // }
  }
  public async create() {
    const isValid = await this.$refs.observer.validate()
    if (!isValid) {
      return
    }
    try {
      await createDiagnostic(this.form)
      this.$bvModal.hide('modal-1')
      this.form = {} as Diagnostic
    } catch {
      // The request interceptor already shows the API message.
    }
  }
}
